<template>
  <div class="container" id="customer-reservation-calendar">
    <calendar-dialog ref="dialog" typeDialog="caregiver"></calendar-dialog>
    <div class="header-container" style="padding: 20px 0px;">
      <el-badge v-bind:is-dot="haveBookingPreviousMonth">
        <el-button icon="el-icon-arrow-left" @click="goPreviousMonth" circle="circle"></el-button>
      </el-badge>
      <div class="header">{{ calendarName }}</div>
      <el-badge v-bind:is-dot="haveBookingNextMonth">
        <el-button icon="el-icon-arrow-right" @click="goNextMonth" circle="circle"></el-button>
      </el-badge>
    </div>
    <vue-tuicalendar ref="calendar" :options="calendarOptions" :schedules="calendarSchedules" @before-create-schedule="beforeCreateSchedule" @click-schedule="showBookingDialog" style="height: 600px; width: 100%;"></vue-tuicalendar>
    <caregiver-history :caregiverHistory="history"></caregiver-history>
  </div>
</template>

<style lang="scss" scoped>
  .container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .right {
    text-align: right;
  }

  .header {
    font-size: 30px;
    font-weight: bold;
  }

  .header-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    justify-content: space-between;
  }

  .el-button.is-circle {
    border-radius: 50%;
    padding: 12px;
    font-size: 25px;
    font-weight: 900;
  }

</style>

<script>
import moment from 'moment'
import CalendarDialog from '@/components/shared/CalendarDialog'
import CalendarScheduleModel from '@/model/CalendarScheduleModel'
import CaregiverHistoryModel from '@/model/CaregiverHistoryModel'
import CaregiverHistory from './CaregiverHistory'
import { GenericAPIHandler } from '../shared/GenericAPIHandler'

export default {
  name: 'CaregiverMatchedCalendar',
  components: {
    CalendarDialog,
    CaregiverHistory,
  },
  mixins: [GenericAPIHandler],
  props: {
    caregiverId: {
      type: Number,
      required: true,
    },
  },
  mounted () {
    this.getCalendar()
    this.getHistory()
  },
  data () {
    return {
      monthMoment: moment().format(),
      calendarSchedules: [],
      reservations: [],
      history: {},
      calendarOptions: {
        defaultView: 'month',
        isReadOnly: true,
        taskView: true,
        scheduleView: true,
        useCreationPopup: false,
        useDetailPopup: false,
        theme: {
          'common.holiday.color': '#000000',
          'common.today.color': '#f00',
          'month.holidayExceptThisMonth.color': '#dfdfdf',
          'month.dayExceptThisMonth.color': '#dfdfdf',
          'month.dayname.borderLeft': 'none',
          'month.dayname.fontSize': '18px',
        },
        template: {
          allday (schedule) {
            let shiftType
            if (schedule.raw.shiftType === 'day') {
              shiftType = `<img src='https://storage.healthathome.in.th/ebe33da4-6df7-4aae-9725-39099ba00701.svg' width="16px" height="16px" />`
            } else {
              shiftType = `<img src='https://storage.healthathome.in.th/74ec3e15-7a26-47d6-8403-79a194bb9a2f.svg' width="14px" height="14px" />`
            }
            switch (schedule.raw.status) {
              case 'matched':
                return `<img src="https://storage.healthathome.in.th/44d87da9-b270-49f3-a209-1f0ca21deb2b.svg" width="16px" height="16px" style="margin-right: 2px;" /> ${shiftType} <span style="opacity: 0.5; font-size: 18px; margin-left: 4px;">(${schedule.title.split('(')[1]}</span>`
            }
          },
          monthMoreTitleDate (date, dayShort) {
            const dayFormatFullName = () => {
              switch (dayShort) {
                case 'อา.': return 'อาทิตย์'
                case 'จ.': return 'จันทร์'
                case 'อ.': return 'อังคาร'
                case 'พ.': return 'พุธ'
                case 'พฤ.': return 'พฤหัส'
                case 'ศ.': return 'ศุกร์'
                case 'ส.': return 'เสาร์'
              }
            }
            const dayFullName = dayFormatFullName(dayShort)
            return `${moment(date, 'YYYY.MM.DD').format('DD')} ${dayFullName}`
          },
        },
        month: {
          visibleScheduleCount: 3,
          daynames: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
          startDayOfWeek: 1,
          narrowWeekend: false,
        },
      },
    }
  },
  computed: {
    calendarName () {
      return moment(this.monthMoment).format('MMMM') + ' ' + moment(this.monthMoment).format('YYYY')
    },
    haveBookingNextMonth () {
      return this.haveBooking('next')
    },
    haveBookingPreviousMonth () {
      return this.haveBooking('prev')
    },
  },
  methods: {
    async getCalendar () {
      try {
        const raw = await this.$api.Caregiver.calendar(this.caregiverId)
        const list = raw.list
        for (let i = 0; i < list.length; i++) {
          list[i].status = 'matched'
          const scheduleItems = CalendarScheduleModel.fromCalendar(list[i])
          this.calendarSchedules = this.calendarSchedules.concat(scheduleItems)
        }
      } catch (error) {
        this.$message.error(error)
      }
    },
    async getHistory () {
      try {
        const raw = await this.$api.Caregiver.gethistory(this.caregiverId)
        this.history = CaregiverHistoryModel.fromJSON(raw)
      } catch (error) {
        this.$message.error(error)
      }
    },
    beforeCreateSchedule (e) {
      e.guide.clearGuideElement()
    },
    showBookingDialog (e) {
      this.$refs.dialog.update(e.schedule, 'caregiver')
    },
    haveBooking (direction) {
      for (let numberOfMonth = 1; numberOfMonth <= 11; numberOfMonth++) {
        for (let i = 0; i < this.calendarSchedules.length; i++) {
          let startBooking = this.calendarSchedules[i] ? moment(this.calendarSchedules[i].start).format('MMMM, YYYY') : ''
          let endBooking = this.calendarSchedules[i] ? moment(this.calendarSchedules[i].end).format('MMMM, YYYY') : ''
          let currentMonth = ''
          if (direction === 'next') currentMonth = moment(this.monthMoment).add(numberOfMonth, 'months').format('MMMM, YYYY')
          else if (direction === 'prev') currentMonth = moment(this.monthMoment).subtract(numberOfMonth, 'months').format('MMMM, YYYY')
          if (startBooking === currentMonth || endBooking === currentMonth) return true
        }
      }
      return false
    },
    goPreviousMonth () {
      this.$refs['calendar'].fireMethod('prev', 'month')
      this.monthMoment = moment(this.monthMoment).subtract(1, 'months')
    },
    goNextMonth () {
      this.$refs['calendar'].fireMethod('next', 'month')
      this.monthMoment = moment(this.monthMoment).add(1, 'months')
    },
    goReservation () {
      this.$router.push({ name: 'ReservationCreate', params: { id: this.caregiverId } })
    },
  },
}
</script>
